import { useQueries, useQueryClient } from "@tanstack/react-query";

import { getCropFootprintByCropIdAndYear, getCropFootprintByCropIdAndYearAdmin } from "services";

import { getEnvironment, getLocalKlimVar, useGetCarbonProgramByFarmId, useUserContext } from "utils";

import { FOOTPRINTING_CROP } from "consts";

export const useGetFootprintingCropFootprints = (farmId?: string, years: number[] = [], cropIds: string[] = [], { enabled = true } = {}) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  const { user } = useUserContext();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getLocalKlimVar("token");

  const allYearCropIdCombos = years.flatMap((year) => cropIds.map((cropId) => ({ year, cropId })));

  // User context hook returns `null` on admin for whatever reason
  const isLoggedIn = isAdmin ? !!token : !!user && !!token;

  return useQueries({
    queries: allYearCropIdCombos.map(({ year, cropId }) => ({
      queryKey: [FOOTPRINTING_CROP, farmId, cropId, year, isAdmin],
      queryFn: () => (isAdmin ? getCropFootprintByCropIdAndYearAdmin(farmId ?? "", year, cropId) : getCropFootprintByCropIdAndYear(cropId, year)),
      enabled: enabled && !!farmId && !!cropId && !!year && isLoggedIn && !!carbonProgram?.platformFeatures?.footprinting?.enabled,
      queryClient,
      gcTime: 60000,
    })),
  });
};
